import { useState, useId, ReactNode } from 'react';
import arrowIcon from '@/assets/icons/arrow-bottom.svg';
import './CollapseGroup.scss';

export interface CollapseGroupProps {
  label: string;
  defaultOpen?: boolean;
  children?: ReactNode;
}

export function CollapseGroup({
  label,
  defaultOpen = false,
  children,
}: CollapseGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [isSettled, setIsSettled] = useState(defaultOpen);
  const contentId = useId();

  const handleToggle = () => {
    if (isOpen) {
      setIsSettled(false);
    }
    setIsOpen(!isOpen);
  };

  const handleTransitionEnd = (e: React.TransitionEvent) => {
    if (e.propertyName === 'max-height' && isOpen) {
      setIsSettled(true);
    }
  };

  return (
    <div className="collapse-group">
      <button
        type="button"
        className={`collapse-group__header${isOpen ? ' collapse-group__header--open' : ''}`}
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span className="collapse-group__label font-bold">{label}</span>
        <img
          src={arrowIcon}
          alt=""
          width={16}
          height={16}
          className={`collapse-group__icon${isOpen ? ' collapse-group__icon--open' : ''}`}
        />
      </button>
      <div
        id={contentId}
        className={`collapse-group__content${isOpen ? ' collapse-group__content--open' : ''}${isSettled ? ' collapse-group__content--settled' : ''}`}
        onTransitionEnd={handleTransitionEnd}
        inert={!isOpen}
      >
        {children}
      </div>
    </div>
  );
}

export default CollapseGroup;
